import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import { Control, Controller, FieldValues, Path, PathValue } from 'react-hook-form';
import { ReactNode } from 'react';

export interface RadioOption_Deprecated {
  label: ReactNode;
  value: string | number;
  disabled?: boolean;
}

interface Props<TFieldValues extends FieldValues> {
  name: Path<TFieldValues>;
  label: string;
  options: RadioOption_Deprecated[];
  required?: boolean;
  disabled?: boolean;
  defaultValue?: PathValue<TFieldValues, Path<TFieldValues>>;
  'aria-label'?: string;
  control: Control<TFieldValues>;
  orientation?: 'row' | 'column';
}

export const RadioInput = <TFieldValues extends FieldValues>({
  name,
  label,
  options,
  required = false,
  disabled,
  defaultValue,
  control,
  orientation = 'column',
  ...rest
}: Props<TFieldValues>) => {
  return (
    <FormControl component="fieldset" required={required}>
      <FormLabel id={`${name}-label`}>{label}</FormLabel>
      <Controller
        name={name}
        defaultValue={defaultValue}
        control={control}
        render={({ field: { value, ref, onChange, onBlur }, fieldState: { error } }) => (
          <>
            <RadioGroup
              ref={ref}
              row={orientation === 'row'}
              aria-labelledby={`${name}-label`}
              aria-label={rest['aria-label']}
              sx={{
                marginLeft: '1em',
                marginTop: '0.5em',
              }}
            >
              {options.map((option) => {
                return (
                  <FormControlLabel
                    // eslint-disable-next-line eqeqeq
                    checked={value == option.value}
                    value={option.value}
                    label={option.label}
                    id={`${name}.${option.value}`}
                    control={
                      <Radio
                        onChange={(e) => onChange(e.target.value)}
                        onBlur={onBlur}
                        color="primary"
                        disabled={disabled || option.disabled}
                      />
                    }
                    key={option.value}
                  />
                );
              })}
            </RadioGroup>
            {!!error && <FormHelperText error>{error.message}</FormHelperText>}
          </>
        )}
      />
    </FormControl>
  );
};
